import { ElementRef, OnInit, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { LeftSideComponent } from './leftSide/leftSide.component';
import { RightSideComponent } from './rightSide/rightside.component';
import { environment } from './../../environments/environment';
import { MainService } from '../_services/main.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Store } from '@ngrx/store';
import { UserService } from '../_services';
import { FormBuilder, Validators } from '@angular/forms';
var UsersComponent = /** @class */ (function () {
    function UsersComponent(store, dialog, router, _appService, spinner, userService, formBuilder) {
        var _this = this;
        this.store = store;
        this.dialog = dialog;
        this.router = router;
        this._appService = _appService;
        this.spinner = spinner;
        this.userService = userService;
        this.formBuilder = formBuilder;
        this.SITE_URL = "" + environment.SITE_URL;
        this.assetURL = "" + environment.assetURL;
        this.currency_symbol = "" + environment.CURRENCY_SYMBOL;
        this.user_id = 0;
        this.bonus_amount = 0;
        this.referrals = [];
        this.tooltipText = 'Copy';
        this.referral_code_validation = '';
        this.referral_send_validation = '';
        this.sucessMessage = '';
        this.editMode = false;
        this.isMac = false;
        this.submitted = false;
        this.disableSave = true;
        this.showLoader = '';
        this.isLoading = true;
        this.isMobile = false;
        this.specialReferCode = '';
        this.newcomponent = "Entered in new component created";
        if (navigator.appVersion.indexOf("Mac") != -1)
            this.isMac = true;
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (this.currentUser != null) {
            this.user_id = this.currentUser.id;
        }
        this.sub_isMobileScreen = this.store.select('isMobileScreen').subscribe(function (state) {
            if (state.length > 0) {
                _this.isMobile = state[0];
            }
        });
    }
    UsersComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.checkSpecialReferCode();
        this.sendReferralForm = this.formBuilder.group({
            email: ['', [Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
        });
        this.spinner.show();
        this.isLoading = true;
        this._appService.getSetting()
            .subscribe(function (shows) {
            if (shows.status === 'success') {
                _this.userSettings = shows.entities;
                _this.isLoading = false;
            }
        }, function (err) {
            console.log(err);
        });
        this.userService.getAllRefferals(this.user_id)
            .subscribe(function (shows) {
            if (shows.status === 'success') {
                _this.referrals = shows.entities;
                _this.bonus_amount = shows.bonus_amount;
            }
        }, function (err) {
            console.log(err);
        });
        this.sub_userData = this.store.select('authData').subscribe(function (state) {
            if (state.length > 0) {
                _this.userData = state[0];
            }
        });
        this.spinner.hide();
    };
    UsersComponent.prototype.ngOnDestroy = function () {
        if (this.sub_isMobileScreen) {
            this.sub_isMobileScreen.unsubscribe();
        }
    };
    UsersComponent.prototype.copyToClipboard = function () {
        var _this = this;
        var val = this.referral_link.nativeElement.innerHTML;
        this.copyIcon.nativeElement.setAttribute("matTooltip", "Copied");
        var selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = val;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
        setTimeout(function () {
            _this.tooltipText = 'Copy';
        }, 3000);
        this.tooltipText = 'Copied';
    };
    UsersComponent.prototype.getTooltipContent = function () {
        return this.tooltipText;
    };
    UsersComponent.prototype.editModeCall = function (editMode) {
        var _this = this;
        this.editMode = editMode;
        setTimeout(function () {
            _this.keydownReferralCode();
        }, 100);
    };
    UsersComponent.prototype.submitRefferals = function () {
        var _this = this;
        this.showLoader = 'Save';
        this.disableSave = true;
        var referalCode = this.referral_code.nativeElement.value;
        this.userService.saveRefferals(referalCode, this.user_id)
            .subscribe(function (res) {
            _this.disableSave = false;
            _this.showLoader = '';
            if (res.status === 'success') {
                _this.editMode = false;
                _this.userData.referral_code = referalCode;
            }
            else {
                _this.referral_code_validation = res.message;
                setTimeout(function () {
                    _this.referral_code_validation = '';
                }, 5000);
            }
        }, function (err) {
            console.log(err);
        });
    };
    UsersComponent.prototype.keydownReferralCode = function () {
        this.referral_code_validation = '';
        var referalCode = this.referral_code.nativeElement.value;
        if (referalCode == this.userData.referral_code) {
            this.disableSave = true;
        }
        else {
            this.disableSave = false;
        }
    };
    Object.defineProperty(UsersComponent.prototype, "f", {
        get: function () { return this.sendReferralForm.controls; },
        enumerable: true,
        configurable: true
    });
    UsersComponent.prototype.sendReferral = function () {
        var _this = this;
        this.submitted = true;
        if (this.sendReferralForm.invalid) {
            return;
        }
        var email_refer = this.sendReferralForm.value.email;
        this.sendReferralForm.controls['email'].setValue(this.sendReferralForm.value.email);
        this.showLoader = 'Send';
        this.userService.sendRefferals(email_refer)
            .subscribe(function (res) {
            _this.showLoader = '';
            _this.submitted = false;
            if (res.status === 'success') {
                _this.sendReferralForm.controls['email'].setValue('');
                _this.sucessMessage = "Your referral email has been sent successfully.";
                setTimeout(function () {
                    _this.sucessMessage = '';
                }, 5000);
            }
            else {
                _this.referral_send_validation = res.message;
                setTimeout(function () {
                    _this.referral_send_validation = '';
                }, 5000);
            }
        }, function (err) {
            console.log(err);
        });
    };
    UsersComponent.prototype.checkSpecialReferCode = function () {
        var _this = this;
        this.userService.checkSpecialReferCode().subscribe(function (res) {
            _this.showLoader = '';
            if (res.status === 'success') {
                _this.specialReferCode = res.entities && res.entities.promo_code ? res.entities.promo_code : '';
            }
        }, function (err) {
            console.log(err);
        });
    };
    return UsersComponent;
}());
export { UsersComponent };
